<template>
  <div>
    <div :style="{ fontSize: fonts.font30 + 'px' }"
    >Select Other Member Account</div>
    <div class="textArea" :style="{ fontSize: fonts.font16 + 'px' }">
      Authorize to transfer from account {{siFormUser}}.
    </div>
    <sendPin
      v-bind:acct="siFormUser"
      optType="xfOther"
      type="Transfer Authorization"
      opt1="XOM"
      opt2=""
      opt3=""
      opt4="">
    </sendPin>
  </div>
</template>

<script>
// eslint-disable-next-line
import utl from '../myUtils';
import sendPin from './sendPin';

export default {
  components: {
    sendPin,
  },
  name: 'xferOther',
  data() {
    return {
      phone: '',
      pin: '',
      how: 'Text',
      access: 'one',
    };
  },
  computed: {
    fonts() {
      return this.$store.getters.getFonts;
    },
    cun() {
      return this.$store.getters.getCuNumber;
    },
    member() {
      return this.$store.getters.getMember;
    },
    siFormUser() {
      return this.$store.getters.getSiFormUser;
    },
    navVer() {
      return this.$store.getters.getNavVer;
    },
  },
  methods: {
    submitRequest() {
      const savePhone = this.phone;
      this.phone = utl.fmtPhone(this.phone);
      if (this.phone === 'invalid phone#') {
        this.showAlert('Please enter a valid phone number');
        this.phone = savePhone;
        return;
      }
      const cuInfo = {};
      cuInfo.cun = this.cun;
      cuInfo.acct = this.siFormUser;
      cuInfo.type = this.how;
      cuInfo.phone = this.phone;
      cuInfo.navVer = this.navVer;
      // utl.diag(`navVer: ${cuInfo.navVer}`);
      // utl.diag(cuInfo);
      this.wsSend('c4RequestPin', cuInfo);
      this.showConfirm('Sending request to server...');
    },
    inputGotFocus() {
      this.hideConfirm();
      this.hideAlert();
    },
    cancel() { // Go Back
      window.history.back();
    },
    submitPin() {
      const savePin = this.pin;
      this.pin = utl.fmtPin(this.pin);
      if (this.pin === 'invalid pin') {
        this.showAlert('Please enter a valid PIN number');
        this.pin = savePin;
        return;
      }
      const cuInfo = {};
      cuInfo.cun = this.cun;
      cuInfo.acct = this.siFormUser;
      cuInfo.pin = this.pin;
      cuInfo.navVer = this.navVer;
      // utl.diag(`navVer: ${cuInfo.navVer}`);
      this.wsSend('c4ValidatePin', cuInfo);
      this.showConfirm(`Checking for valid pin for account ${this.siFormUser}.`);
    },
    hideConfirm() {
      this.$store.commit('setConfirmShow', false);
    },
    showConfirm(message) {
      this.$store.commit('setConfirmMessage', message);
    },
    hideAlert() {
      this.$store.commit('setAlertShow', false);
    },
    showAlert(message) {
      this.$store.commit('setAlertMessage', message);
    },
    diag(message) {
      this.$store.commit('showDiag', message);
    },
    writeDiag(message) {
      this.$store.commit('putDiag', message);
    },
    wsSend(rpc, myObject) {
      const data = Object.assign({}, myObject);
      data.rpcName = rpc;
      this.$store.commit('sendObjToServer', data);
    },
    goBack() {
      // this.$store.commit('setPageIndex', 0); /* go to pg 0 since we aren't logged in */
      window.history.back();
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/xferOther.vue